import React from "react";
import { Box, HStack, Icon, Image, Text } from "@chakra-ui/react";
import Wave from "assets/our-work/lower-splash.png";
import Paji from "assets/home/paji.png";
import TiltedImage from "assets/home/phonecard1.png"; // New image

import { FaChevronDown } from "react-icons/fa6";

function Header() {
  return (
    <Box bg="#005770" pt={24} color="#F1DED0" height={{md:"90vh"}} position="relative">
      <HStack
        mb={4}
        pl={{ base: 4, sm: 10, lg: 12 }}
        justify="space-between"
        maxW={{ base: "85%", sm: "80%", lg: "80%" }}
        align="center"
        position="relative"
      >
        <Box maxW="max-content">
          <Text fontSize={{ base: "3xl", md: "5xl", lg: "8xl" }}>
            Selected Work
          </Text>
          <Image
            src={TiltedImage}
            alt="Tilted Image"
            position="absolute"
            top={{ base: "1px", md: "20px" }}
            right={{ base: "100px", md: "480px" }}
            width={{ base: "60px", md: "100px", lg: "120px" }}
            transform="rotate(15deg)"
            zIndex="1"
            data-animated="true"
            className="fade-in-up"
          />
          <HStack>
            <Text fontSize={{ base: "3xl", md: "5xl", lg: "8xl" }}>21-23</Text>
            <Icon
              as={FaChevronDown}
              boxSize={{ base: "20px", md: "30px", lg: "50px" }}
            />
          </HStack>
        </Box>

        <Box
          bg="#D9D9D9"
          width={{ base: "100px", md: "200px", lg: "300px" }}
          height={{ base: "100px", md: "200px", lg: "300px" }}
          position="relative"
        ></Box>
      </HStack>

      <Image src={Wave} width="100%" position={{md:"absolute"}} bottom={{md:"0"}}/>

      <Image
        src={Paji}
        position="absolute"
        bottom="0"
        right={{ base: 1, sm: 8 }}
        height={{ base: "80px", md: "200px", lg: "auto" }}
        data-animated="true"
      />
    </Box>
  );
}

export default Header;
